import {SerializedStyles} from '@emotion/react';
import {css, Slider, SliderProps, useTheme} from '@mui/material';
import React from 'react';
import {GetStylesFunction} from 'src/js/common/types';

interface OwnProps extends SliderProps {
  inputCss?: SerializedStyles;
  label: string;
}

type Props = OwnProps;

export const DlMuiSlider: React.FC<Props> = (props) => {
  const {inputCss, min, max, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});

  const marks =
    min != null && max != null
      ? [
          {
            value: min,
            label: `${min}`,
          },
          {
            value: max,
            label: `${max}`,
          },
        ]
      : false;

  function valuetext(value: number) {
    return `${value}`;
  }

  return (
    <Slider
      data-name={'dl-mui-slider--slider'}
      {...restProps}
      size={'small'}
      marks={marks}
      min={min}
      max={max}
      css={styles.slider}
      getAriaValueText={valuetext}
      disableSwap
    />
  );
};

DlMuiSlider.displayName = 'DlMuiSlider';

const getStyles: GetStylesFunction = (options) => ({
  sliderWrapper: css`
    height: 100%;
    width: 176px;
    display: flex;
    flex-direction: column;
    position: relative;
  `,
  slider: css(
    {
      display: 'flex',
      alignSelf: 'center',
      width: '150px',
      marginTop: '8px',
      marginBottom: '5px',

      '& .MuiSlider-track': {
        backgroundColor: 'var(--dlTheme-500)',
        border: 'none',
      },
      '& .MuiSlider-rail': {
        backgroundColor: 'var(--dlTheme-500)',
      },
      '& .MuiSlider-thumb': {
        backgroundColor: 'var(--dlTheme-500)',
      },
      '& .MuiSlider-mark': {
        backgroundColor: 'var(--dlTheme-500)',
      },
      '& .MuiSlider-valueLabel': {
        backgroundColor: 'var(--dlThemeGray-700)',
        zIndex: 1300,
        width: 'fit-content',
        maxWidth: '300px',
        color: `${options?.theme?.palette.common.white}`,
        borderRadius: '16px',
        padding: '6px',
        top: '-4px',
        '&:before': {display: 'none'},
      },
    },
    options?.params?.inputCss
  ),
});
